module.exports = __webpack_public_path__ + "img/icon_delivery.0ed22090.svg";